export function getLevel( idealCandidate, dataId, levelId, dataType ) {
  const data = idealCandidate[dataType].find(skill => skill.id === dataId);

  if (!data) return null;
  return data.levels.find(level => level.id === levelId);
}